document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", init);

function init() {
  console.log("%cCPB is loaded", "color: #1e82dd; font-size: 18px");
  modifyProductInCartInit();
}

function modifyProductInCartInit() {
  if (window.location.search.indexOf("&modifyProduct=") === -1) return;
  let keyId = window.location.search.split("&modifyProduct=")[1];
  keyId = keyId.split("&")[0];

  const addToCartBtn = document.querySelector(".cpb-add-to-cart-button");
  if (addToCartBtn) {
    const span = addToCartBtn.querySelector("span");
    if (span) {
      span.innerHTML = "Update Cart";
    }

    addToCartBtn.addEventListener("click", function () {
      const url = `/cart/change.js?id=${encodeURIComponent(keyId)}&quantity=0`;
      fetch(url).then((response) => {
        // Handle response
      });
    });
  }
}
